import { render } from "./side-nav-outer-toolbar.vue?vue&type=template&id=525d61a0&scoped=true"
import script from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=525d61a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525d61a0"]])

export default __exports__